module.exports = __webpack_public_path__ + "static/media/5.fa68e074.jpg";